import { gql, useMutation } from '@apollo/client';
import { IconButton, useDisclosure, useToast } from '@chakra-ui/react';
import * as React from 'react';

import { ExportOrganizationSearchInput } from '@/graphql-types/globalTypes';
import { DownloadIcon } from '@/imports/ui/chakra/feather';

import {
  OrganizationSearchExportButton_ExportOrganizationSearch,
  OrganizationSearchExportButton_ExportOrganizationSearchVariables,
} from './graphql-types/OrganizationSearchExportButton_ExportOrganizationSearch';

import { SuccessModal } from './components/SuccessModal/SuccessModal';

const EXPORT_ORGANIZATION_SEARCH = gql`
  mutation OrganizationSearchExportButton_ExportOrganizationSearch(
    $input: ExportOrganizationSearchInput!
  ) {
    exportOrganizationSearch(input: $input) {
      result
    }
  }
`;

export const OrganizationSearchExportButton: React.FC<{
  input: ExportOrganizationSearchInput;
}> = ({ input }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [exportOrganizationSearch, exportOrganizationSearchResult] =
    useMutation<
      OrganizationSearchExportButton_ExportOrganizationSearch,
      OrganizationSearchExportButton_ExportOrganizationSearchVariables
    >(EXPORT_ORGANIZATION_SEARCH);

  const onClick = async (): Promise<void> => {
    try {
      await exportOrganizationSearch({
        variables: {
          input,
        },
      });
      onOpen();
    } catch (err) {
      toast({
        title: 'Failed to start organization search export ',
        status: 'error',
      });
    }
  };

  return (
    <>
      <IconButton
        colorScheme="primary"
        variant="outline"
        aria-label="download"
        borderColor="primary.500"
        icon={<DownloadIcon color="primary.500" boxSize={5} />}
        onClick={onClick}
        isLoading={exportOrganizationSearchResult.loading}
      />
      <SuccessModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
